<app-link
    [appRouterLink]="subCollectionLink"
    class="card gtm-premium-collection-mezzanine-card selenium-premium-collection-mezzanine-card"
    [attr.data-gtmlabel]="premiumSectionItem.title"
    [attr.data-gtmsectionname]="sectionName"
>
    <img [src]="imageURL" [alt]="imageAlt" />
    <div class="title" *ngIf="windowSize.isDesktop">
        {{ premiumSectionItem.title | safeTruncate: 60 }}
    </div>
    <div class="title" *ngIf="windowSize.isSmallDesktop">
        {{ premiumSectionItem.title | safeTruncate: 49 }}
    </div>
</app-link>
